module.exports = __webpack_public_path__ + "img/PlacesToGo.593dff99.svg";